var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.dataRows,"disable-pagination":""},scopedSlots:_vm._u([{key:"item.unit_price",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatWithCurrency(item.item.unit_price, _vm.order.currency_code))+" ")]}},{key:"item.line_total",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatWithCurrency(item.item.quantity * item.item.unit_price, _vm.order.currency_code))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }